import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetInvoicePreview as GetInvoicePreviewQuery,
    GetInvoicePreviewVariables as GetInvoicePreviewQueryVariables,
    GetInvoicePreview_invoicePreview as InvoicePreview,
    InvoicePreviewInput,
} from 'nutshell-graphql-types';

import GET_INVOICE_PREVIEW from '../queries/get-invoice-preview.graphql';

export const useGetInvoicePreview = (
    input: InvoicePreviewInput
): {
    invoicePreview: InvoicePreview | null | undefined;
    isLoading: boolean;
    errorMessage: string | null | undefined;
} => {
    const {
        loading: isLoading,
        data,
        error,
    } = useQuery<GetInvoicePreviewQuery, GetInvoicePreviewQueryVariables>(GET_INVOICE_PREVIEW, {
        variables: {input},
        skip: !input.crmPlanCode || !input.addOns || !input.numberOfUsers,
    });

    const invoicePreview = data ? data.invoicePreview : null;

    return {
        invoicePreview,
        isLoading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
